module.exports = __webpack_public_path__ + "static/media/inspection.cec09fad.svg";